import { Route } from 'react-router-dom'

import { Layout } from '../Layout/Layout'
import { DocumentPreview } from '../documentPreview/DocumentPreview'

import { AuthorisedRoute } from './authorisedRoute/AuthorisedRoute'

export function AuthorisedRoutes() {
  return [
    <Route
      key="DocumentPreview"
      path="/document-preview"
      element={
        <AuthorisedRoute>
          <DocumentPreview />
        </AuthorisedRoute>
      }
    />,
    <Route
      key="Layout"
      path="/*"
      element={
        <AuthorisedRoute>
          <Layout />
        </AuthorisedRoute>
      }
    />
  ]
}
